import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Modal controller
export default class extends Controller {
  static values = {
    aiStatusUrl: String,
    aiProcessing: Boolean,
  };

  static targets = ["loadingOverlay"];

  connect() {
    if (this.aiProcessingValue) {
      this.showLoadingOverlay();
      this.pollAiProcessingStatus();
    }
  }

  showLoadingOverlay() {
    this.loadingOverlayTarget.classList.remove("d-none");
  }

  hideLoadingOverlay() {
    window.location.reload();
  }

  async pollAiProcessingStatus() {
    this.pollingInterval = setInterval(async () => {
      try {
        const response = await get(this.aiStatusUrlValue);
        const contentType = response.headers.get("content-type");

        // If we get HTML instead of JSON, it's an error page
        if (contentType && contentType.includes("text/html")) {
          clearInterval(this.pollingInterval);
          const html = await response.text();
          // Replace the current page with the error page
          document.documentElement.innerHTML = html;
          return;
        }

        const data = await response.response.json();
        if (!data.ai_processing) {
          this.hideLoadingOverlay();
          clearInterval(this.pollingInterval);
        }
      } catch (error) {
        console.error("Error fetching AI processing status:", error);
      }
    }, 5000);
  }
}
